import { request } from "../utils/api";

const buildQuery = (params = {}) => {
  const entries = Object.entries(params).filter(
    ([, v]) => v !== undefined && v !== null && v !== "",
  );
  if (!entries.length) return "";
  return `?${new URLSearchParams(entries).toString()}`;
};

/** Search ICD-10 catalog (defaults when q is empty). */
export const searchIcd10Diagnoses = (params) =>
  request(`/diagnoses/icd10/search${buildQuery(params)}`);

/** Create a new ICD-10 catalog row (code + description + clinical group). */
export const createIcd10Diagnosis = (data) =>
  request(`/diagnoses/icd10`, {
    method: "POST",
    body: JSON.stringify(data),
  });
